"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireWildcard(require("./4.0.0"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledTree = require("./StyledTree");
var _YkbTree$propTypes, _YkbTree$defaultProps;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var YkbTree = /*#__PURE__*/function (_Component) {
  function YkbTree() {
    (0, _classCallCheck2.default)(this, YkbTree);
    return _callSuper(this, YkbTree, arguments);
  }
  (0, _inherits2.default)(YkbTree, _Component);
  return (0, _createClass2.default)(YkbTree, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledTree.StyledTreeContainer, {
          prefixCls: _this.props.prefixCls,
          theme: theme,
          showLine: _this.props.showLine
        }, function (prefixCls) {
          return /*#__PURE__*/_react.default.createElement(_.default, (0, _extends2.default)({}, _this.props, {
            prefixCls: prefixCls
          }));
        });
      });
    }
  }]);
}(_react.Component);
YkbTree.TreeNode = _.TreeNode;
YkbTree.displayName = 'Tree';
YkbTree.propTypes = (_YkbTree$propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  checkable: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  showLine: _propTypes.default.bool,
  showIcon: _propTypes.default.bool,
  defaultExpandAll: _propTypes.default.bool,
  expandAll: _propTypes.default.bool,
  defaultExpandedKeys: _propTypes.default.array,
  expandedKeys: _propTypes.default.array,
  onExpand: _propTypes.default.func
}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_YkbTree$propTypes, "expandedKeys", _propTypes.default.array), "defaultCheckedKeys", _propTypes.default.array), "autoExpandParent", _propTypes.default.bool), "onCheck", _propTypes.default.func), "checkedKeys", _propTypes.default.array), "onSelect", _propTypes.default.func), "onSearch", _propTypes.default.func), "defaultSelectedKeys", _propTypes.default.array), "selectedKeys", _propTypes.default.array), "draggable", _propTypes.default.bool), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_YkbTree$propTypes, "multiple", _propTypes.default.bool), "collapseTree", _propTypes.default.bool), "caseSensitive", _propTypes.default.bool), "editable", _propTypes.default.object), "searchValue", _propTypes.default.string), "inputProps", _propTypes.default.object), "debounce", _propTypes.default.bool), "debounceDuration", _propTypes.default.number));
YkbTree.defaultProps = (_YkbTree$defaultProps = {
  className: '',
  showIcon: false,
  selectable: true,
  checkable: false,
  disabled: false,
  showLine: false,
  defaultExpandAll: false,
  expandAll: false,
  collapseTree: true,
  caseSensitive: false,
  defaultExpandedKeys: [],
  expandedKeys: []
}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_YkbTree$defaultProps, "expandedKeys", []), "defaultCheckedKeys", []), "autoExpandParent", false), "checkedKeys", []), "defaultSelectedKeys", []), "selectedKeys", []), "draggable", false), "multiple", false), "onSearch", function onSearch(text, expandedKeys) {}), "debounce", false), (0, _defineProperty2.default)(_YkbTree$defaultProps, "debounceDuration", 500));
var _default = exports.default = YkbTree;